var scope_0 = require('/Users/frankintarter/git/franklintarter/personal-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;
var scope_1 = require('/Users/frankintarter/git/franklintarter/personal-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/48794acf2a00f92987030ae0ba12d044.js').default;
var scope_2 = require('/Users/frankintarter/git/franklintarter/personal-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/70e337d81f41572852499abf7e361efb.js').default;
var scope_3 = require('/Users/frankintarter/git/franklintarter/personal-website/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c74adf7ece1f2114abaa652f3fe06c07.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3 )
    